import landingPageMetaDaImgSrc from "views/Landing/assets/landing-page-meta-da.png";
import landingPageMetaEnImgSrc from "views/Landing/assets/landing-page-meta-en.png";
import landingPageMetaFiImgSrc from "views/Landing/assets/landing-page-meta-fi.png";
import landingPageMetaNoImgSrc from "views/Landing/assets/landing-page-meta-no.png";
import landingPageMetaPlImgSrc from "views/Landing/assets/landing-page-meta-pl.png";
import landingPageMetaSvImgSrc from "views/Landing/assets/landing-page-meta-sv.png";

import { useOnLanguageChange } from "@/hooks/Translations";

const languages: Record<string, string> = {
  en: landingPageMetaEnImgSrc,
  fi: landingPageMetaFiImgSrc,
  pl: landingPageMetaPlImgSrc,
  sv: landingPageMetaSvImgSrc,
  da: landingPageMetaDaImgSrc,
  no: landingPageMetaNoImgSrc,
};

export const useLandingPageMetaImgSrc = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const currentLanguage = useOnLanguageChange();
  return languages[currentLanguage];
};
